/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { InvalidResponse, ProductReviewState, Review } from '../../model';
import {
	addProductReviewsMultimedia,
	cleanProductReviewsMultimedia,
	setBVPixelIsAvailable,
	setBVPixelState,
	setProductReviewProductIdentifier,
	setProductReviewProsCons,
	setProductReviewState,
	setProductReviewSummary,
	setProductReviews,
	setProductStatistics,
	setReviewAISummary,
	setReviewOnDrawer,
	updateProductReviewsMultimedia
} from '../actions';

export const initialProductReviewsState: ProductReviewState = {
	productIdentifier: '',
	reviewSummary: new InvalidResponse(),
	reviews: [],
	reviewsMultimedia: new InvalidResponse(),
	statistics: new InvalidResponse(),
	product: new InvalidResponse(),
	currentReview: '',
	BVPixel: new InvalidResponse(),
	aiReview: new InvalidResponse(),
	prosCons: new InvalidResponse(),
};

export const productReviewsReducers = createReducer(
	initialProductReviewsState,
	on(setProductReviewState, (state, { productIdentifier, reviewSummary, reviews, product }) => ({
		...state,
		productIdentifier,
		reviewSummary,
		reviews,
		product
	})),
	on(setProductReviewProductIdentifier, (state, { productIdentifier }) => ({
		...state,
		productIdentifier
	})),
	on(setProductReviewSummary, (state, { reviewSummary }) => ({
		...state,
		reviewSummary
	})),
	on(setProductReviews, (state, { reviews }) => ({
		...state,
		reviews
	})),
	on(setReviewAISummary, (state, { aiReview }) => ({
		...state,
		aiReview
	})),
	on(setProductStatistics, (state, { statistics }) => ({
		...state,
		statistics
	})),
	on(setReviewOnDrawer, (state, { currentReview }) => ({
			...state,
			currentReview
		})),
	on(addProductReviewsMultimedia, (state, { reviewsMultimedia }) => ({
			...state,
			reviewsMultimedia
		})),
	on(cleanProductReviewsMultimedia, (state) => ({
			...state,
			reviewsMultimedia: []
		})),
	on(updateProductReviewsMultimedia, (state, { reviewMultimedia }) => {
		const updatedReviewMultimedia: Review[] =
			state.reviewsMultimedia instanceof InvalidResponse
				? [reviewMultimedia]
				: [...state.reviewsMultimedia, reviewMultimedia];
		return {
			...state,
			reviewsMultimedia: updatedReviewMultimedia
		};
	}),
	on(setBVPixelState, (state, { brand, category, productId }) => ({
			...state,
			BVPixel: { brand, category, productId }
		})),
	on(setProductReviewProsCons, (state, prosCons) => ({
			...state,
			prosCons
		})),
	on(setBVPixelIsAvailable, (state, { isBVPixelReady }) => ({
			...state,
			BVPixel: { ...state.BVPixel, isBVPixelReady }
		}))
);

export const productReviewsReducer = (state: ProductReviewState, action: Action) =>
	productReviewsReducers(state, action);
